import TemplateContents from './TemplateContents';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class extends TemplateContents{
    constructor(param){
        super(param);
    }

    init() {
        super.init();
    }

    reset(){
        super.reset();
        this.setVars();
    }

    destruct(){
        super.destruct();
        this.killCultureFadeScrollTriggers();
        if (this.myCall) this.myCall.kill();
    }

    setVars(){
        super.setVars();
    }

    setDom(){
        super.setDom();
        this.root = document.querySelector('main.culture');
    }

    initEvents(){
        super.initEvents();
    }

    killCultureFadeScrollTriggers(){
        if (this.cultureFadeScrollTriggers && this.cultureFadeScrollTriggers.length) {
            this.cultureFadeScrollTriggers.forEach((st) => st.kill());
        }
        this.cultureFadeScrollTriggers = [];
    }

    setupCultureFadeReveal(){
        this.killCultureFadeScrollTriggers();
        if (!this.root) return;
        const items = this.root.querySelectorAll('.culture-fade');
        if (!items.length) return;
        this.cultureFadeScrollTriggers = [];
        items.forEach((el) => {
            const st = ScrollTrigger.create({
                trigger: el,
                start: 'top 85%',
                once: true,
                onEnter: () => el.classList.add('show'),
            });
            this.cultureFadeScrollTriggers.push(st);
        });
        ScrollTrigger.refresh();
    }

    start(isLanding){
        // アニメーションはここに追記
        this.setupCultureFadeReveal();
    }

    scrollHandler(){

    }

    enterframe(){

    }

    enterframeThinOut(){

    }

    executeResize() {
        super.executeResize();
    }
}
